import { MutationTree, ActionTree, GetterTree } from "vuex/types";
import { Profile, KYCProfile } from "@foxone/api/src/models/account";
import { ReferralInfo, Membership } from "@foxone/api/src/models/foxone";

const state = (): AccountState => ({
  profile: null,
  kycProfile: null,
  referral: null,
  membership: null,
  loading: false,
  kycLink: "",
  loginCodeSendTime: 0
});

export type AccountState = ReturnType<
  () => {
    profile: Profile | null;
    referral: ReferralInfo | null;
    membership: Membership | null;
    kycProfile: KYCProfile | null;
    loading: boolean;
    kycLink: string;
    loginCodeSendTime: number;
  }
>;

const getters: GetterTree<AccountState, {}> = {
  isMixinBinded(state) {
    return state.profile && state.profile.is_mixin_bind;
  }
};

const mutations: MutationTree<AccountState> = {
  SET_PROFILE(state, profile) {
    state.profile = profile;
  },
  SET_KYC_PROFILE(state, profile) {
    state.kycProfile = profile;
  },
  SET_REFERRAL(state, referral) {
    state.referral = referral;
  },
  SET_MEMBERSHIP(state, data) {
    state.membership = data;
  },
  SET_LOADING(state, value) {
    state.loading = value;
  },
  SET_KYC_LINK(state, value) {
    state.kycLink = value;
  },
  SET_LOGIN_CODE_SEND_TIME(state, value) {
    state.loginCodeSendTime = value;
  },
  REMOVE_PROFILE(state) {
    state.profile = null;
  },
  REMOVE_REFERRAL(state) {
    state.referral = null;
  },
  REMOVE_MEMBERSHIP(state) {
    state.membership = null;
  }
};

const actions: ActionTree<AccountState, {}> = {
  async loadProfile({ commit }) {
    const profile = await this.$api.account.getProfile();
    commit("SET_PROFILE", profile);
  },
  async loadKYCProfile({ commit }) {
    const profile = await this.$api.account.getKYCProfile();
    commit("SET_KYC_PROFILE", profile);
  },
  async loadReferral({ commit }) {
    const referral = await this.$api.foxone.getReferralInfo();
    commit("SET_REFERRAL", referral);
  },
  async loadMembership({ commit }) {
    const data = await this.$api.foxone.getMembership();
    commit("SET_MEMBERSHIP", data);
  },
  async loadKYCLink({ commit, state }, callback) {
    const data = await this.$api.account.getKYCLink(callback);
    commit("SET_KYC_LINK", data);
    return state.kycLink;
  },
  async loadAccountData({ dispatch }) {
    try {
      await Promise.all([
        dispatch("loadProfile"),
        dispatch("loadKYCProfile")
        // dispatch("loadReferral"),
        // dispatch("loadMembership")
      ]);
    } catch (error) {
      console.log(error);
    }
  },
  removeAccountData({ commit }) {
    commit("REMOVE_PROFILE");
    commit("REMOVE_REFERRAL");
    commit("REMOVE_MEMBERSHIP");
    commit("SET_KYC_PROFILE", null);
    commit("SET_LOGIN_CODE_SEND_TIME", 0);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
